import Icon from '@/components/ui/AppIcon';

interface Capability {
  id: number;
  icon: string;
  title: string;
  description: string;
  specs: string[];
}

const capabilities: Capability[] = [
{
  id: 1,
  icon: 'BoltIcon',
  title: 'Fiber Laser Cutting',
  description: 'High-speed precision cutting with 6kW fiber laser technology for complex geometries and tight tolerances.',
  specs: ['6kW Laser Power', 'Up to 1" Mild Steel', '±0.1mm Tolerance', '3000mm x 1500mm Double Bed']
},
{
  id: 2,
  icon: 'CubeIcon',
  title: 'CNC Punching',
  description: 'Rapid prototyping and high-volume production with automated tool changing and multi-hit capabilities.',
  specs: ['33-Ton Capacity', '58-Station Turret', '0.5mm - 6mm Thickness', 'Auto Tool Change']
},
{
  id: 3,
  icon: 'ArrowPathIcon',
  title: 'Precision Bending',
  description: 'Advanced press brake technology with CNC control for consistent, repeatable bends across production runs.',
  specs: ['220-Ton Capacity', '12ft Bed Length', '±0.5° Angle Accuracy', 'Offline Programming']
}];


export default function CapabilitiesOverview() {
  return (
    <section className="lg:py-24 bg-background py-20">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
            <Icon name="CpuChipIcon" size={20} variant="solid" className="text-primary" />
            <span className="text-sm font-cta font-semibold text-primary">Core Capabilities</span>
          </div>
          
          <h2 className="text-3xl lg:text-5xl font-headline font-bold text-foreground mb-6">
            Comprehensive Fabrication Solutions
          </h2>
          
          <p className="text-lg text-muted-foreground leading-relaxed">
            Our integrated fabrication center combines cutting-edge technology with decades of manufacturing expertise to deliver precision components at scale.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {capabilities.map((capability) =>
          <div
            key={capability.id}
            className="bg-card rounded-lg border border-border p-8 hover:shadow-lg transition-all duration-base group">

              <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-all duration-base">
                <Icon name={capability.icon as any} size={32} variant="outline" className="text-primary" />
              </div>
              
              <h3 className="text-xl font-headline font-bold text-foreground mb-3">
                {capability.title}
              </h3>
              
              <p className="text-muted-foreground mb-6 leading-relaxed">
                {capability.description}
              </p>
              
              <div className="space-y-2">
                {capability.specs.map((spec, index) =>
              <div key={index} className="flex items-center space-x-2">
                    <Icon name="CheckCircleIcon" size={16} variant="solid" className="text-success flex-shrink-0" />
                    <span className="text-sm text-foreground">{spec}</span>
                  </div>
              )}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}